import { Box, Button, CssBaseline, CssVarsProvider, FormControl, FormLabel, Grid, Input, Table, Typography } from "@mui/joy";
import EmployeeSidebar from "../../EmployeeSidebar";
import { useNavigate } from "react-router-dom";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useState } from "react";
import { BorderBottom } from "@mui/icons-material";
import FeedbackModals from "./FeedbackModals";
import { useGetUploadTDSBatchFilesMutation, useGetValidateTDSMutation } from "../../../services/invoices/InvoiceApiSlice";
import { toast } from "react-toastify";

export default function TdsFilesUpload() {

    const [uploadedFiles, setUploadedfiles] = useState<any>([]);
    const [savedFiles, setSavedFiles] = useState<any>([]);
    const [verifyFileList, setVerifyFileList] = useState<any>([]);
    const [getValidateFiles, { isLoading: isValidating }] = useGetValidateTDSMutation();
    const [getUploadAllFiles, { isLoading: isUploadingFiles }] = useGetUploadTDSBatchFilesMutation();

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files: any = e.target.files;

        var isPdf = 0;
        for (let i = 0; i < files.length; i++) {
            if (files[i] && !["application/pdf"].includes(files[i].type)) {
                isPdf = 1;

            }
        }
        if (isPdf === 1) {
            toast.error("Only PDF file are allowed!");
            e.target.value = ""; // Clear the input
            return;
        }
        setVerifyFileList([]);
        setUploadedfiles([...files]);
        // const file = e.target.files?.[0];
        // const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB

        // if (file.size > maxSizeInBytes) {
        //   toast.error("File size exceeds 5 MB limit.");
        //   e.target.value = ""; // Clear the input
        //   return;
        // }
        // quarter(file);

        // var base64 = await fileToBase64(file);
        // const body = {
        //   fiscal_year: fiscalYear,
        //   quarter: cquarter,
        //   vendor_code: vendorDetails.lifnr,
        //   attachment_name: file.name,
        //   attachment: base64,
        //   mime_type: file.type,
        // };
        // try {
        //   const response = await uploadFleMutation(body);
        // } catch (err) {
        //   let errorMessage = "An error occurred. " + (err?.data?.message || err?.message);
        //   toast.error(errorMessage);
        // }
    };
    const onHandleVerifyTDSFiles = async () => {
        try {
            var fileName = [];
            uploadedFiles.map((item) => fileName.push(item.name));
            const response = await getValidateFiles({ file_names: [...fileName] });
            if (response?.data?.status) {
                setVerifyFileList(response?.data?.results);
            } else {
                toast.error(JSON.stringify(response));
            }

        } catch (err) { console.log(err) }
    }

    var allSaved = [];
    const onHandleUploadTDSFiles = async (initial, step = 30) => {
        try {
            var data = new FormData();

            let fileList = [...uploadedFiles];
            let verifyList = [...verifyFileList];

            let batchFile = fileList.slice(initial, initial + step);
            let batchVerify = verifyList.slice(initial, initial + step);

            for (let i = 0; i < batchFile.length; i++) {
                data.append("files", batchFile[i]);
            }
            data.append("metadata", JSON.stringify(batchVerify));
            const response = await getUploadAllFiles(data);
            if (response?.data?.status) {
                if (uploadedFiles.length > (initial + step)) {
                    allSaved = allSaved.concat([...response?.data?.results]);
                    onHandleUploadTDSFiles(initial + step);
                } else {
                    allSaved = allSaved.concat([...response?.data?.results]);
                    toast.success("All file uploaded.");
                    setSavedFiles([...allSaved]);
                    allSaved = [];
                }
            } else {
                toast.error(JSON.stringify(response));
            }
        } catch (err) { console.log(err) }
    }

    return (
        <CssVarsProvider disableTransitionOnChange>
            <CssBaseline />
            <Box sx={{ display: "flex", minHeight: "92dvh", background: "white" }}>
                <EmployeeSidebar />
                <div className="form-center">
                    <div className="add-entry-outer upoad-box-design register-box" style={{ padding: "20px", width: '70%' }}>
                        <Grid container rowSpacing={4} columnSpacing={5} sx={{ width: '100%', margin: '0px' }}>
                            <Grid>
                                <FormControl>
                                    <FormLabel>Upload TDS files</FormLabel>
                                    <Button component="label" sx={{ maxWidth: "fit-content" }} variant="outlined" startDecorator={<CloudUploadIcon />} style={{ margin: "7px 0px", width: '100%' }}>
                                        Choose File
                                        <input type="file" multiple name="attachment" hidden accept="application/pdf" onChange={handleFileChange} />
                                    </Button>
                                </FormControl>
                            </Grid>
                            <Grid>
                                <FormControl>
                                    <FormLabel> &nbsp;</FormLabel>
                                    <Button style={{ margin: "7px 0px", width: '100%' }} onClick={() => onHandleVerifyTDSFiles()} disabled={uploadedFiles?.length === 0 || verifyFileList?.length > 0 || isValidating}>
                                        Validate files
                                    </Button>
                                </FormControl>
                            </Grid>
                            <Grid>
                                <FormControl>
                                    <FormLabel> &nbsp;</FormLabel>
                                    <Button style={{ margin: "7px 0px", width: '100%' }} onClick={() => onHandleUploadTDSFiles(0)} disabled={verifyFileList?.length === 0 || savedFiles.length > 0}>
                                        {isUploadingFiles ? 'Sending...' : 'Upload all files'}
                                    </Button>
                                </FormControl>
                            </Grid>
                        </Grid>
                        <Box sx={{ maxHeight: '300px', overflow: 'auto' }}>
                            {(uploadedFiles?.length > 0 && verifyFileList?.length === 0 && savedFiles.length === 0) && <Typography component={'h4'}>Added File List</Typography>}
                            {(verifyFileList?.length > 0 && savedFiles.length === 0) && <Typography component={'h4'}>Validate File List</Typography>}
                            {isValidating && <Typography sx={{ color: 'green' }}>Validating Files...</Typography>}

                            {(uploadedFiles?.length > 0 && verifyFileList?.length === 0 && savedFiles.length === 0) && <Table borderAxis="both" sx={{ borderTop: '1px solid rgba(99 107 116 / 0.2)' }}>
                                <tbody style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>
                                    <tr>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Sr. No.</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>File Name</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>File Size</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>File Type</th>
                                    </tr>
                                </tbody>
                                <tbody>
                                    {
                                        uploadedFiles?.map((item, index) => (
                                            <tr key={'file' + index}>
                                                <td>{index + 1}</td>
                                                <td>{item.name}</td>
                                                <td>{bytesToMB(item.size)}</td>
                                                <td>{item.type}</td>
                                            </tr>
                                        ))
                                    }

                                </tbody>
                            </Table>}
                            {(verifyFileList?.length > 0 && savedFiles.length === 0) && <Table borderAxis="both" sx={{ borderTop: '1px solid rgba(99 107 116 / 0.2)' }}>
                                <tbody style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>
                                    <tr>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Sr. No.</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Vendor Code</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Vendor Name</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Pan No.</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Fiscal Year</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Quarter</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)', width: '25%' }}>File Name</th>
                                    </tr>
                                </tbody>
                                <tbody>
                                    {
                                        verifyFileList?.map((item, index) => (
                                            <tr key={'file' + index}>
                                                <td>{index + 1}</td>
                                                <td>{item.vendor_code}</td>
                                                <td>{item.vendor_name}</td>
                                                <td>{item.pan}</td>
                                                <td>{item.fiscal_year}</td>
                                                <td>{item.quarter}</td>
                                                <td><span style={{ wordWrap: 'break-word' }}>{item.file_name}</span></td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>}
                            {(savedFiles.length > 0) && <Table borderAxis="both" sx={{ borderTop: '1px solid rgba(99 107 116 / 0.2)' }}>
                                <tbody style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>
                                    <tr>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Sr. No.</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Vendor Code</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>File Name</th>
                                        <th style={{ borderBottom: '1px solid rgba(99 107 116 / 0.2)' }}>Status</th>
                                    </tr>
                                </tbody>
                                <tbody>
                                    {
                                        verifyFileList?.map((item, index) => (
                                            <tr key={'file' + index}>
                                                <td>{index + 1}</td>
                                                <td>{item.vendor_code}</td>
                                                <td><span style={{ wordWrap: 'break-word' }}>{item.file_name}</span></td>
                                                <td>{item.status === "SUCCESS" ? <span style={{ color: 'green' }}>Saved</span> : <span style={{ color: 'red' }}>Not Saved</span>}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>}
                        </Box>
                    </div>
                </div>
            </Box>
            {/* <FeedbackModals /> */}
        </CssVarsProvider>
    );
}

function bytesToMB(bytes, decimals = 2) {
    if (!bytes || bytes < 0) return "0 MB";
    const mb = bytes / (1024 * 1024);
    return `${mb.toFixed(decimals)} MB`;
}